import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { errorMsgForCommonDropdown, getCurrentUserData, getSignMultiSelectDropdown, isObject, notifyBugsnagError, requiredErrorMsgForCommonDropdown, showToast } from "../../../common/utils/Functions";
import useFetch from "../../../hooks/useFetch";
import { signModalSchema } from "../../../validations/signModalSchema";
import ModalLayout from "../../layouts/ModalLayout";
import ReactSelectField from "../../theme/ReactSelectField";
import ThemeButton from "../../theme/ThemeButton";

interface Iprops {
    handleClose: () => void;
    show: boolean;
    title?: string;
    editModal?: boolean;
    signsList?: any
    handleSignAdd?: any
    loading?: boolean;
    formikErrorMesg?: any;
}

const SignsModal = ({
    handleClose,
    title,
    show,
    signsList,
}: Iprops) => {

    const [propertyError, setPropertyError] = useState('')
    const [commonDropDownError, setCommonDropDownError] = useState('')
    const [propertyListDropdown, setPropertyListDropdown] = useState<{ label: string, value: number }[]>([]);
    const [signStyleListDropdown, setSignStyleListDropdown] = useState<{ label: string, value: any }[]>([]);
    const [signSizeListDropdown, setSignSizeListDropdown] = useState<{ label: string, value: any }[]>([]);
    const [selectedProperty, setSelectedProperty] = useState<any>();
    const [commondropDownOptions, setCommondropdownOptions] = useState<any>([{ label: '', value: '' }])
    const [selectedCommondropDownOptions, SetSelectedCommondropDownOptions] = useState<any>();

    const { uuid } = useParams();
    const orgData = getCurrentUserData(`${uuid}`)
    /** -----@signscardApi ------ */
    const [
        signsCardApi,
        {
            response: signsCardsResponse,
            loading: signsCardLoading,
            error: signsCardError,
        },
    ] = useFetch("/common/qr-sign/add", {
        method: "post",
    });

    /** -----@signscardApi ------ */
    const [
        propertyListApi,
        {
            response: propertyListResponse,
            loading: propertyListLoading,
            error: propertyListError,
        },
    ] = useFetch("/property/list", {
        method: "post",
    });

    /**
      * initialise property-services list api
      */
    const [PropertyServiceListApi, { response: propertyServiceListRes, error: propertyServiceListErr }] =
        useFetch("propertyservices/list", {
            method: "post",
        });

    /**
    * initialise property-employees list api
    */
    const [
        PropertyEmployeeListApi,
        { response: propertyEmployeeListRes, error: propertyEmployeeListErr },
    ] = useFetch("propertyemployees/list", {
        method: "post",
    });

    /**
    * initialise property-room list api
    */
    const [
        PropertyRoomListApi,
        { response: propertyRoomListRes, error: propertyRoomListError, loading: propertyRoomListLoading },
    ] = useFetch("propertyrooms/list", {
        method: "post",
    });

    /** Api for fetching sign style */
    const [
        signSizeStyleApi,
        { response: signSizeStyleResponse, loading: signStyleLoading, error: signStyleError },
    ] = useFetch(`/common/qr-signs`, {
        method: "get",
    });

    /**
  * @Call all property data using @listApi constant
  */
    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                propertyListApi({
                    start: 0,
                    limit: -1,
                    search: '',
                });
            } catch (e: any) {
                notifyBugsnagError(e, {
                    api: "propertyListApi",
                });
            }
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const propertyData = propertyListResponse?.data?.list?.map((property: any) => {
            return {
                label: property?.name,
                value: property?.uuid,
                id: property?.id
            }
        })
        setPropertyListDropdown(propertyData)
    }, [propertyListResponse])


    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                signSizeStyleApi();
            } catch (e: any) {
                notifyBugsnagError(e, {
                    api: "propertyListApi",
                });
            }
        }, 500);
        return () => clearTimeout(timer);
    }, []);


    const handleChangeProperty = (e: any) => {
        const propertyValue = e;
        setSelectedProperty(propertyValue);
        SetSelectedCommondropDownOptions(null)
        setPropertyError('')
        setCommonDropDownError('')
    };

    const handleCommonDropDownChange = (e: any) => {
        const commonDropDownValue = e;
        SetSelectedCommondropDownOptions(commonDropDownValue)
        setCommonDropDownError('')
    }

    useEffect(() => {
        const dropdownsPayload = {
            property_uuid: selectedProperty?.value,
            start: 0,
            limit: -1,
            search: ''
        }

        switch ((formik.values.sign_for as any)?.value) {
            case 3: PropertyServiceListApi(dropdownsPayload)
                break;
            case 5: PropertyEmployeeListApi(dropdownsPayload)
                break;
            case 4: PropertyRoomListApi(dropdownsPayload)
        }
    }, [selectedProperty?.value])

    useEffect(() => {
        if (propertyServiceListRes && (formik.values.sign_for as any)?.value === 3) {
            const propertyServiceData = propertyServiceListRes?.data?.list?.map((service: any) => {
                return {
                    label: service?.service_details?.name,
                    value: service?.id
                }
            })
            setCommondropdownOptions(propertyServiceData)
        }
        if (propertyEmployeeListRes && (formik.values.sign_for as any)?.value === 5) {
            const propertyEmployeeData = propertyEmployeeListRes?.data?.list?.map((employee: any) => {
                return {
                    label: employee?.name,
                    value: employee?.id
                }
            })
            setCommondropdownOptions(propertyEmployeeData)
        }
        if (propertyRoomListRes && (formik.values.sign_for as any)?.value === 4) {
            const propertyRoomData = propertyRoomListRes?.data?.list?.map((room: any) => {
                return {
                    label: room?.name,
                    value: room?.id
                }
            })
            setCommondropdownOptions(propertyRoomData)
        }
    }, [propertyServiceListRes, propertyEmployeeListRes, propertyRoomListRes])

    useEffect(() => {
        if (signsCardsResponse) {
            showToast(signsCardsResponse.message as string, "success");
            formik.setFieldValue('sign_size_uuid', '');
            formik.setFieldValue('sign_uuid', '');
            formik.setFieldValue('sign_for', '');
            handleClose()
            formik.resetForm({ values: formik.initialValues, errors: {} });
            signsList({
                start: 0,
                limit: 10
            })
            setPropertyError('')
            setCommonDropDownError('')
        }
        if (signsCardError) {
            showToast(signsCardError.message as string, "error");
        }
    }, [signsCardsResponse, signsCardError])



    // Define static options for the "Sign For" dropdown
    const allSignForOptions = [
        { label: "Organization", value: 1 },
        { label: "Property", value: 2 },
        { label: "Service", value: 3 },
        { label: "Employee", value: 5 },
        { label: "Room", value: 4 },
    ];

    // Check if properties exist
    const hasProperties = propertyListDropdown && propertyListDropdown.length > 0;

    // Filter options based on whether properties exist
    const signForOptions = hasProperties
        ? allSignForOptions
        : [{ label: "Organization", value: 1 }];

    const formik = useFormik({
        initialValues: {
            sign_size_uuid: '',
            sign_uuid: "",
            sign_for: null,
            is_default_sign: 0,
        },
        validationSchema: signModalSchema,
        onSubmit: (values) => {
            const formValues: any = values
            const payload: any = {}
            const propertyValue: any = propertyListDropdown?.filter((item: any) => item?.value === selectedProperty?.value);
            Object.keys(formValues).forEach((key) => {
                payload[key] = isObject(formValues[key]) ? formValues[key]?.value : formValues[key]
            })
            if ((formik.values.sign_for as any)?.value === 1) {
                payload['ids'] = [orgData?.organization_details?.id]
                payload['is_default_sign'] = 0
            }
            if ((formik.values.sign_for as any)?.value === 2) {
                payload['ids'] = [propertyValue[0]?.id]
                payload['is_default_sign'] = 0
            }
            if ((formik.values.sign_for as any)?.value !== 1 && (formik.values.sign_for as any)?.value !== 2) {
                payload['ids'] = [selectedCommondropDownOptions?.value]
            }
            delete payload["property"];
            if ((formik.values.sign_for as any)?.value !== 1 && !selectedProperty?.value) {
                setPropertyError('Property is required.')
            } else if ((formik.values.sign_for as any)?.value !== 1 && (formik.values.sign_for as any)?.value !== 2 && !selectedCommondropDownOptions?.value) {
                setCommonDropDownError(requiredErrorMsgForCommonDropdown((formik.values.sign_for as any)?.value))
            } else {
                signsCardApi(payload)
            }
        },
    });


    const sizeDescriptions: Record<string, string> = {
        '28x44': 'Wind Sign',
        '3.5x5.5': 'Desktop Plaque',
        '8.5x11': 'Letter Size',
        '3.5x2': 'Business Card',
        '16x20': 'Window Cling',
    };

    // Manual size → style mapping (API does not send size_id / description)
    // This Manual Decision for this is asked to dev team on 21 Oct 2026
    const sizeStyleMap: Record<number, number[]> = {
        1: [1, 7],       // 28x44 (Wind Sign)
        2: [2],          // 3.5x5.5 (Desktop Plaque)
        3: [3, 4, 5, 8, 11], // 8.5x11 (Letter Size) — 11: Break Room Flyer
        4: [6, 9],       // 3.5x2 (Business Card)
        5: [10],         // 16x20 (Window Cling)
    };

    useEffect(() => {
        if (!signSizeStyleResponse?.data) return;

        const signSizeData = signSizeStyleResponse.data.qrSizes?.map((item: any) => {
            const name = item.name || '';
            const desc = sizeDescriptions[name] || sizeDescriptions[String(name).replace(/\s/g, '')];
            return {
                label: desc ? `${name} (${desc})` : name,
                value: item.uuid,
                id: item.id,
            };
        });
        setSignSizeListDropdown(signSizeData);

        const selectedSizeId = (formik.values.sign_size_uuid as any)?.id;
        const allowedStyleIds = sizeStyleMap[selectedSizeId] || [];
        const signStyleData = signSizeStyleResponse.data.qrSigns
            ?.filter((item: any) => allowedStyleIds.includes(item.id))
            .map((item: any) => ({
                label: item.name || '',
                value: item.uuid,
                id: item.id,
            }));
        setSignStyleListDropdown(signStyleData || []);
    }, [signSizeStyleResponse, formik.values.sign_size_uuid]);


    useEffect(() => {
        formik.setFieldValue("sign_uuid", "")
    }, [formik.values.sign_size_uuid])

    // Auto-select Organization when no properties exist (runs when modal opens or property list loads)
    useEffect(() => {
        if (show) {
            // Check if property list has been loaded (even if empty)
            const propertyListExists = propertyListResponse?.data?.list !== undefined;
            const hasPropertiesCount = propertyListDropdown && propertyListDropdown.length > 0;

            // Auto-select Organization if no properties exist
            if (propertyListExists && !hasPropertiesCount) {
                formik.setFieldValue('sign_for', { label: "Organization", value: 1 });
            }
        }
    }, [show, propertyListResponse, propertyListDropdown])

    const isAnyValue = () => {
        const formikValues: any = formik?.values
        const isValid = (value: any) => value !== null && value !== undefined && value !== '';
        const hasValidValue = Object.values(formikValues).some(isValid);
        return hasValidValue
    }


    return (
        <ModalLayout
            title={title}
            show={show}
            size={500}
            handleToggle={() => {
                handleClose()
                setPropertyError('')
                setCommonDropDownError('')

                formik.resetForm({ values: formik.initialValues, errors: {} });
            }}
        >
            <Row className="g-xl-4 g-3">
                <Col xxl={12} xl={12} style={{ position: "relative" }}>
                    <ReactSelectField
                        name="sign_size_uuid"
                        options={signSizeListDropdown}
                        label="Sign Size"
                        placeholder="Select Size"
                        className="form_select"
                        formik={formik}
                        margin={true}
                        formikErrorMesg={formik.errors?.sign_size_uuid}
                    />
                </Col>
                <Col xxl={12} xl={12} style={{ position: "relative" }}>
                    <ReactSelectField
                        name="sign_uuid"
                        options={signStyleListDropdown}
                        label="Sign Style"
                        className={`form_select ${!formik.values.sign_size_uuid ? 'cursor-not-allowed opacity-50' : ''}`}
                        placeholder="Select Style"
                        formik={formik}
                        value={formik.values?.sign_uuid && (formik.values?.sign_uuid as any)?.label}
                        margin={true}
                        formikErrorMesg={formik.errors?.sign_uuid}
                        isDisabled={!formik.values.sign_size_uuid}
                    />
                </Col>
                {
                    hasProperties && (
                        <Col xxl={12} xl={12} style={{ position: "relative" }}>
                            <ReactSelectField
                                name="sign_for"
                                options={signForOptions}
                                label="Sign For"
                                placeholder="Select Sign For"
                                onChange={(e) => {
                                    formik.setFieldValue('sign_for', e)
                                    setSelectedProperty(null)
                                    setCommonDropDownError('')
                                    SetSelectedCommondropDownOptions(null)
                                }}
                                className="form_select"
                                formik={formik}
                                margin={true}
                                formikErrorMesg={isObject(formik.errors?.sign_for) ? formik.errors?.sign_for : { value: formik.errors?.sign_for }}
                            />
                        </Col>
                    )
                }

                {
                    formik.values.sign_for && (formik.values.sign_for as any)?.value != 1 && <Col xxl={12} xl={12} style={{ position: "relative" }}>
                        <ReactSelectField
                            name="property"
                            options={propertyListDropdown}
                            value={selectedProperty}
                            label="Select Property"
                            placeholder="Select Property"
                            margin={true}
                            onChange={(e) => handleChangeProperty(e)}
                            className="form_select"
                        />
                    </Col>
                }
                {!(propertyListDropdown?.length > 0) &&
                    <span style={{ color: '#d22b2b', fontSize: '12px', textAlign: 'right', marginTop: '5px' }}>
                        {errorMsgForCommonDropdown((formik.values.sign_for as any)?.value, true)}
                    </span>
                }
                {
                    getSignMultiSelectDropdown((formik.values.sign_for as any)?.value).length > 0 && selectedProperty?.value && getSignMultiSelectDropdown((formik.values.sign_for as any)?.value)?.map((item: any) => {
                        return <Col xxl={12} xl={12} style={{ position: "relative" }} key={item?.sign_for}>
                            <ReactSelectField
                                name={item.name}
                                value={selectedCommondropDownOptions}
                                options={commondropDownOptions}
                                label={item.label}
                                margin={true}
                                placeholder={item?.placeholder}
                                onChange={(e) => handleCommonDropDownChange(e)}
                                className="form_select"
                            />
                        </Col>
                    })
                }
                {(commondropDownOptions.length > 0) && commonDropDownError && !selectedCommondropDownOptions?.value && <span style={{ color: '#d22b2b', fontSize: '12px', textAlign: 'right', marginTop: '5px' }}>
                    {commonDropDownError}
                </span>}

                {propertyError && !selectedProperty?.value && <span style={{ color: '#d22b2b', fontSize: '12px', textAlign: 'right', marginTop: '5px' }}>
                    {propertyError}
                </span>}
                {!(commondropDownOptions?.length > 0) && selectedProperty?.value &&
                    <span style={{ color: '#d22b2b', fontSize: '12px', textAlign: 'right', marginTop: '5px' }}>
                        {errorMsgForCommonDropdown((formik.values.sign_for as any)?.value)}
                    </span>
                }
            </Row>
            <Modal.Footer>
                <ThemeButton loading={signsCardLoading} onClick={() => formik.handleSubmit()
                } disabled={!isAnyValue() || signsCardLoading}>
                    {" "}
                    Create
                </ThemeButton>
            </Modal.Footer>
        </ModalLayout >
    );
};

export default SignsModal;
